import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { formatDate, YEAR_DATE_TIME_FORMAT } from 'utils/date';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import { CompositeService } from 'types';

import { Label } from 'components/Statistic/Label';

import cn from './styles.module.scss';

const ITEMS_NUMBER = 5;

export function ActivityLog({ className }) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { rows } = await CompositeService.getCompositesHistory({ offset: 0, limit: ITEMS_NUMBER });
      setActivities(rows);
      setLoading(false);
    })();
  }, []);

  return (
    <div className={classNames(cn.activityLog, className)}>
      <Label>
        <ClockCircleOutlined />
        Recent Activities
      </Label>
      <Skeleton loading={loading} paragraph={{ rows: 5, width: '100%' }} active={loading} />
      <div className={cn.items}>
        {activities.map((activity, index) => (
          <div key={index} className={cn.activity}>
            <div>
              {activity.userName} {activity.description}
            </div>
            {activity.context ? (
              <div className={cn.context}>
                  {activity.context}
              </div>
            ) : ''}
            <div className={cn.date}>{formatDate(activity.date, YEAR_DATE_TIME_FORMAT)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
